<template>
  <v-container>
    <v-dialog v-model="openFlag" fullscreen hide-overlay transition="dialog-bottom-transition">
      <c-card class="white">
        <v-toolbar dark color="primary">
          <c-btn iconName="mdi-close" @click="openFlag = false" elevation="0" color="primary"></c-btn>
          <v-toolbar-title>수동 배차</v-toolbar-title>
        </v-toolbar>

        <v-row justify="center">
          <div class="schedule-wrapper">
            <v-container>
              <v-row class="mt-10 mx-5" style="height: 40px">
                <v-menu
                  :close-on-content-click="true"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <div style="width:200px">
                      <v-text-field
                        label="예약일자"
                        v-model="selectedDate"
                        prepend-icon="event"
                        readonly dense
                        v-on="on"
                        :disabled="selectedDateFlag"
                      ></v-text-field>
                    </div>
                  </template>
                  <c-date-picker 
                    v-model="selectedDate"
                    firstDayOfWeek="1" noTitle="true" scrollable="true"
                    :allowedDates="allowedDates"
                    :selectedDate="selectedDate"
                    locale="ko-kr"
                  ></c-date-picker>
                </v-menu>

                <c-time-picker
                  label="예약시간"
                  v-model="selectedTime"
                  :minute-interval="5"
                  :h-range="[0,24]"
                  :autoScroll="true"
                  :defaultAutoScrollValue="7"
                  inputWidth="200px"
                />
                <c-btn class="blue mx-3" @click="onDeliver">배차</c-btn>

                <v-spacer></v-spacer>
                <v-checkbox
                  v-model="disableBreakTime"
                  label="휴무 제외"
                ></v-checkbox>
              </v-row>

              <v-row class="pt-3 pb-5" align="center" justify="end" style="height: 20px">
                <div class="schedule-index__item" style="background-color: #bbbbbb;"/>
                <div class="schedule-index__text">퇴근/휴무</div>

                <div class="schedule-index__item" style="background-color: #f7b632;"/>
                <div class="schedule-index__text">예약</div>

                <div class="schedule-index__item" style="background-color: #2cccc7;"/>
                <div class="schedule-index__text">휴식</div>
              </v-row>
             <!-- <v-row justify="end" style="height: 25px">
                <v-checkbox
                  v-model="disableBreakTime"
                  label="휴무 제외"
                ></v-checkbox>
              </v-row>-->
            </v-container>

            <c-scheduler class="mt-3"
                         :headerList="getHeaderList"
                         :contentList="schedulerContentList"
                         :guideLine="timeGuideLine"
                         @onClickContentRow="onClickSchedule"
                         :contentsHeight="calHeight"
            >
              <template #contentItem="{item}">
                <v-tooltip bottom v-if="item.item">
                  <template v-slot:activator="{ on }">
                    <div style="width: 100%; height: 100%" @mouseover="on.mouseenter" @mouseleave="on.mouseleave"/>
                  </template>
                  <span>출발지: {{item.item.info.departure}}</span>
                  <br/>
                  <span>도착지: {{item.item.info.destination}}</span>
                  <br/>
                  <span>출발시간: {{item.item.info.startTime}}</span>
                  <br/>
                  <span>종료시간: {{item.item.info.endTime}}</span>
                </v-tooltip>
              </template>
              <template #contentIcon="{ item }">
                <v-tooltip bottom v-if="item.item">
                  <template v-slot:activator="{ on, attrs }" >
                    <img v-on="on" v-bind="attrs" src="../../../assets/archive.png" alt="" :style="getIconStyle">
                  </template>
                  <span>{{getDeliveryParcelType(item.item.info)}}</span>
                  <br/>
                  <span>출발지: {{item.item.info.expectedDeparture}}</span>
                  <br/>
                  <span>도착지: {{item.item.info.expectedDestination}}</span>
                  <br/>
                  <span>예상출발시간: {{item.item.info.expectedStartTime}}</span>
                  <br/>
                  <span>예상도착시간: {{item.item.info.expectedEndTime}}</span>
                </v-tooltip>
              </template>
            </c-scheduler>
          </div>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import CScheduler from "../../Default/Common/CScheduler";
  export default {
    components: {CScheduler},
    props: {
      open: {
        type: Boolean,
        default: false
      },
      reservationFlag: {
        type: Boolean
      },
      deliveryCheckData: {
        type: Object
      },
    },
    data() {
      return {
        openFlag: false,

        selectedTime: '00:00',
        selectedDate: this.$func.curDateString(),
        deliveryDuration: 0,
        timeGuideLine: {
          startLeft: 0,
          endLeft: 0,
          color: 'red',
        },
        schedulerHeaders: [0, 24],
        schedulerOneMinuteWidth: 1,

        schedulerContentList: {},

        selectedSchedule: {},

        disableBreakTime: true, // 휴무 제외 플래그

        calHeight: 0,

        deliveryList: [],
        iconHeight: 20,
      }
    },
    computed: {
      getHeaderList() {
        let headerList = [];
        for (let i = this.schedulerHeaders[0]; i < this.schedulerHeaders[1]; i++) {
          headerList.push(this.$moment({hour: i}).format('HH:00'));
        }
        return headerList;
      },
      selectedDateFlag() {
        const userRole = this.$store.state.userInfo.role;
        return userRole === 'TM';
      },
      getIconStyle() {
        const iconHeight = this.iconHeight;
        const iconMarginTop = parseInt(iconHeight) / 2 * -1;
        return {
          height: iconHeight+'px',
          marginTop: iconMarginTop +'px',
        };
      }
    },
    watch: {
      open(newVal) {
        if(newVal) {
          //init data
          const schedulerHeight = window.innerHeight - 370;
          this.calHeight = schedulerHeight < 300? 300: schedulerHeight;
          this.selectedSchedule = {};
          this.schedulerContentList = {};
          this.disableBreakTime = true;

          const deliveryData = this.deliveryCheckData;
          if (deliveryData) {
            const startDateTime = this.$func.dateTimeToString(deliveryData.expectedStartTime);
            this.selectedDate = this.$func.dateToString(startDateTime);
            this.selectedTime = this.$moment(startDateTime).format('HH:mm');

            this.deliveryDuration = this.$moment.duration(this.$moment(deliveryData.expectedEndTime).diff(this.$moment(deliveryData.expectedStartTime)))
                .asMinutes();

            this.reqGetScheduleList();
          }
        }
        this.openFlag = newVal;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
      selectedDate(newVal) {
        this.selectedSchedule = {};
        this.reqGetScheduleList(newVal);
      },
      selectedTime(newVal) {
        const selectedSchedule = {...this.selectedSchedule};
        const driverIds = Object.keys(selectedSchedule);
        for(let i=0; driverIds && i<driverIds.length; i++) {
          this.deSelectedSchedule(driverIds[i]);
        }

        const newMoment = this.$moment(newVal, 'HH:mm');
        const duration = this.$moment.duration(newMoment.diff(this.$moment(this.schedulerHeaders[0], 'H')));

        const startLeft = this.schedulerOneMinuteWidth * parseInt(duration.asMinutes());
        const endLeft = startLeft + this.deliveryDuration * this.schedulerOneMinuteWidth;

        this.timeGuideLine = {
          ...this.timeGuideLine,
          startLeft,
          endLeft
        }
      },
      disableBreakTime(newVal, oldVal) {
        if(newVal !== oldVal) {
          this.selectedSchedule = {};
          this.reqGetScheduleList();
        }
      },
    },
    methods: {
      allowedDates(date) {
        return !this.$moment(date, 'YYYY-MM-DD').isBefore(this.$moment('00:00:00', 'HH:mm:ss'));
      },
      onDeliver() {
        const deliveryTime = this.$moment(this.selectedDate + ' ' + this.selectedTime);
        const nowTime = this.$moment();

        if(deliveryTime.isBefore(nowTime)) {
          this.$store.commit('snackbar', {msg: '과거 시간은 접수가 불가능합니다. 시간을 다시 설정해주세요.'});
          return;
        }
        this.reqDeliver();
        // this.openFlag = false;
      },
      // 선택된 스케줄 해제 // param : 차량id, 기사id, 선택된 스케줄 배열의 idx
      deSelectedSchedule(driverId) {
        const vehicleIds = this.selectedSchedule[driverId];
        for(let i=0; vehicleIds && i<vehicleIds.length; i++) {
          this.schedulerContentList[vehicleIds[i]]
            .subContents[driverId]
            .items.splice(-1, 1);
        }
        delete this.selectedSchedule[driverId];
        // this.selectedSchedule.splice(selectedIdx, 1);
      },
      onClickSchedule(schedule) {
        const {vehicleId, driverId, items} = schedule;

        // - 클릭된 데이터 선택/해제 확인
        if(this.selectedSchedule[driverId]) {
          this.deSelectedSchedule(driverId);
          return;
        }

        // - 선택 가능 개수 확인
        else if(Object.keys(this.selectedSchedule).length >= 1) {
          this.$store.commit('snackbar', {msg: '선택 가능한 개수를 초과하였습니다.'});
          return;
        }

        // - 가능 스케줄인지 확인
        //   - 불가능할 경우 알림창
        if(items.length < 2) { //휴무
          this.$store.commit('snackbar', {msg: '선택 가능한 시간이 아닙니다.'});
          return;
        } else {
          const {startLeft, endLeft} = this.timeGuideLine;
          // let flag = false;
          let flag = true;

          // length=3이상, 출퇴근 시간 외 스케줄이 있는 경우
          if(items.length > 2) {
            if (items[items.length-2].width > startLeft || items[items.length-1].left < endLeft) {
              flag = false;
            }
          }
          // length=2, 출퇴근 시간만 있는 경우 // items[0] - 출근, items[1] - 퇴근
          else if(items[0].width > startLeft || items[1].left < endLeft) {
            flag = false;
          }

          if(flag) { // 가능한 경우
            this.schedulerContentList[vehicleId]
              .subContents[driverId]
              .items.push({
              color: 'red',
              width: this.timeGuideLine.endLeft - this.timeGuideLine.startLeft,
              left: this.timeGuideLine.startLeft
            });

            //동일 기사 스케줄 찾기
            const findVehicleIdsByDriverId = Object.keys(this.schedulerContentList).filter(
              key => {
                return (key !== vehicleId) && (Object.keys(this.schedulerContentList[key].subContents).indexOf(driverId) > -1)
            });
            //동일 기사에도 스케줄 표시
            for(let i=0; i<findVehicleIdsByDriverId.length; i++) {
              this.schedulerContentList[findVehicleIdsByDriverId[i]]
                .subContents[driverId]
                .items.push({
                  color: 'rgba(256, 0, 0, 0.4)',
                  width: this.timeGuideLine.endLeft - this.timeGuideLine.startLeft,
                  left: this.timeGuideLine.startLeft
              });
            }

            this.selectedSchedule[driverId] = [vehicleId, ...findVehicleIdsByDriverId];
          } else {
            this.$store.commit('snackbar', {msg: '선택 가능한 시간이 아닙니다.'});
          }

        }
      },
      getContentItems(driverObject, color, vehicleId) {
        let {driver, driverSchedule, reservation, deliveries} = driverObject;
        let items = [];
        const workOffColor = '#808080';
        const otherScheduleColor = '#e1e1e1';
        const breakTimeColor = '#2cccc7';

        //휴무 제외
        if(this.disableBreakTime && (!driverSchedule || driverSchedule.onWorkTime === driverSchedule.endWorkTime)) {
          return null;
        }

        // reservation
        for(let i=0; reservation && i<reservation.length; i++) {
          let {startTime, endTime, vehicleId: {id}, resrvState, customerName, departure, destination} = reservation[i];

          // else if(resrvState.configValue === 'rs_done') {
          //   continue;
          // }

          let width = 0;
          let left = 0;

          const startTimeM = this.$func.stringToDatetime(startTime);
          const endTimeM = this.$func.stringToDatetime(endTime);

          const diff = parseInt(this.$moment.duration(endTimeM.diff(startTimeM)).asMinutes());
          if (diff > 0) {
            width = diff * this.schedulerOneMinuteWidth;

            const diffWithStart = parseInt(this.$moment.duration(startTimeM.diff(this.$moment(startTimeM.format('YYYY-MM-DD')+' '+this.schedulerHeaders[0], 'YYYY-MM-DD H'))).asMinutes());
            left = diffWithStart * this.schedulerOneMinuteWidth;

          } else {
            // TODO - check case
            console.log('check others/ reservation: ', reservation[i]);
          }

          let itemColor = '';
          if(id !== vehicleId)  { // 해당 차량의 예약이 아닐 경우 (해당 기사의 다른 차량의 예약)
            itemColor = otherScheduleColor;
          } else if((customerName === departure)&&(customerName === destination)) { // 휴식
            itemColor = breakTimeColor;
          } else { // 예약
            itemColor = color;
          }

          items.push({
            color: itemColor,
            width,
            left: left<0? 0: left,
            item : (id === vehicleId)? {
              driverId: driver.id,
              vehicleId,
              info: reservation[i]
            }: null
          });
        } // end reservation

        // Add delivery icon
        if (deliveries.length > 0) {
          let dLeft = 0;
          for (let delivery of deliveries) {
            const deliveryStartLine = this.$func.stringToDatetime(delivery.expectedStartTime);

            const diffWithStart = parseInt(
                this.$moment.duration(
                    deliveryStartLine.diff(this.$moment(deliveryStartLine.format('YYYY-MM-DD') + ' ' + this.schedulerHeaders[0], 'YYYY-MM-DD H'))
                ).asMinutes()
            );

            dLeft= diffWithStart * this.schedulerOneMinuteWidth;

            items.push({
              type: 'delivery',
              left: dLeft < 0 ? 0 : dLeft,
              iconSrc: '../../../assets/archive.png',
              item: {
                info: delivery
              }
            });
          }
        }


        // driverSchedule
        if(!driverSchedule) { //휴무 일 경우
          let width = this.schedulerOneMinuteWidth * 60 * (this.schedulerHeaders[1] - this.schedulerHeaders[0]);
          items.push({
            color: workOffColor,
            width,
            left: 0,
          });

        } else { // 출퇴근시간 존재 할 경우
          let {onWorkTime, endWorkTime} = driverSchedule;
          let width = 0;
          let left = 0;

          const displayStartTimeM = this.$moment(this.schedulerHeaders[0], 'H');
          const displayEndTimeM = this.$moment(this.schedulerHeaders[1], 'H');
          let workTimeM = this.$moment(onWorkTime, 'HH:mm');
          let endWorkTimeM = this.$moment(endWorkTime, 'HH:mm');

          // 근무시작시간이 display된 시간보다 작은 경우
          if(workTimeM.diff(displayStartTimeM) < 0) {
            workTimeM = displayStartTimeM;
          }
          //근무종료시간이 display된 시간보다 작은 경우
          if(endWorkTimeM.diff(displayStartTimeM) < 0) {
            endWorkTimeM = displayStartTimeM;
          }
          //근무시작시간이 display 된 시간보다 큰 경우
          if(displayEndTimeM.diff(workTimeM) < 0) {
            workTimeM = displayEndTimeM;
          }
          //근무종료시간이 display된 시간보다 큰 경우
          if(displayEndTimeM.diff(endWorkTimeM) < 0) {
            endWorkTimeM = displayEndTimeM;
          }

          const diffWithStart = parseInt(this.$moment.duration(workTimeM.diff(displayStartTimeM)).asMinutes());
          width = diffWithStart * this.schedulerOneMinuteWidth;
          items.push({
            color: workOffColor,
            width: width < 0 ? 0 : width,
            left: left < 0 ? 0 : left,
          });

          width = parseInt(this.$moment.duration(displayEndTimeM.diff(endWorkTimeM)).asMinutes())
            * this.schedulerOneMinuteWidth;
          left = parseInt(this.$moment.duration(endWorkTimeM.diff(displayStartTimeM)).asMinutes())
            * this.schedulerOneMinuteWidth;
          items.push({
            color: workOffColor,
            width: width < 0 ? 0 : width,
            left: left < 0 ? 0 : left,
          });
        } //end driverSchedule


        return { title: driver.name, driverId: driver.id, vehicleId, items };
      },
      async reqDeliver() {
        try {
          const driverId = Object.keys(this.selectedSchedule)[0];
          const startTime = this.selectedDate + ' ' + this.selectedTime + ':00';
          const endTime = this.$moment(startTime, 'YYYY-MM-DD HH:mm:ss').add(this.deliveryDuration, 'm').format('YYYY-MM-DD HH:mm:ss');

          const reqData = {
            id: this.deliveryCheckData.id,
            vehicleId: this.selectedSchedule[driverId][0],
            driverId: driverId,
            expectedStartTime: startTime,
            expectedEndTime: endTime,
          };

          const res = await this.$api.manualDelivery(reqData);

          if (!res.data) {
            throw "배차에 실패하였습니다.";
          }

          this.$emit('update:deliveryCheckData', res.data);
          this.$emit('update:deliveryFlag', "success");

          // info alert띄움, 확인 클릭하면 details 페이지로 이동
          this.openFlag = false;

          this.$store.commit('snackbar', {color: 'blue', timeout: 2000, msg: '예약이 완료되었습니다.'});

        } catch (err) {
          this.$emit('update:deliveryFlag', "failure");
          this.$store.commit('alert',
              {
                err, where:'onDeliver',
                open: true, persistent: true,
                callBack: () => {
                  this.openFlag = false;
                }
              });
        }
      },
      async reqGetScheduleList(selectedDate) {
        try {
          const res = await this.$api.getReservationScheduleByDate(selectedDate || this.selectedDate);

          let contentList = {};

          // 스케줄 데이터 정제
          for(let i=0; i<res.data.length; i++) {

            const {vehicle, mainDriver, subDriver1, subDriver2} = res.data[i];

            let subContents = {};

            let items = [];
            let color = '';
            //mainDriver
            if(mainDriver && mainDriver.driver) {
              // color = '#0070c0';
              color='#f7b632';
              const content =  this.getContentItems(mainDriver, color, vehicle.id);
              if(content) subContents[mainDriver.driver.id] = content;
            }

            //subDriver1
            if(subDriver1 && subDriver1.driver) {
              // color = '#8FAADC';
              color='#f7b632';
              const content = this.getContentItems(subDriver1, color, vehicle.id);
              if(content) subContents[subDriver1.driver.id] = content;
            }

            //subDriver2
            if(subDriver2 && subDriver2.driver) {
              // color = '#9DC3E6';
              color='#f7b632';
              const content = this.getContentItems(subDriver2, color, vehicle.id);
              if(content) subContents[subDriver2.driver.id] = content;

              // if(content) {
              //   content['schedule'] = subDriver2.driverSchedule;
              //   subContents[subDriver2.driver.id] = content;
              // }
            }

            //save
            if(Object.keys(subContents).length > 0) {
              contentList[vehicle.id] = {
                title: vehicle.plateNo,
                driverName: Object.values(subContents)[0].title,
                subContents
              };
            }
          }

          let map = Object.entries(contentList).sort((a,b) => {
            return a[1].driverName > b[1].driverName ? 1 : -1;
          });

          this.schedulerContentList = Object.fromEntries(map);
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqGetScheduleList'});
        }
      },
      getDeliveryParcelType(item) {
        const configParcels = JSON.parse(item.parcelType);
        return configParcels.map(item => item.configName).join();
      }
    },
  }
</script>
<style scoped>
  .schedule-wrapper {
    width: 1300px;
    overflow-x: auto
  }
  .schedule-index__item {
    width: 20px;
    height: 14px;
    margin-left: 20px;
    margin-right: 5px
  }
  .schedule-index__text {
    font-size: 14px;
  }
</style>
